(function() {
  'use strict';

  // ── Config ─────────────────────────────────────────────────
  var PAGE_SIZE = 25;
  var DEBOUNCE_MS = 300;

  // ── DOM refs ───────────────────────────────────────────────
  var loadingEl    = document.getElementById('orders-loading');
  var errorEl      = document.getElementById('orders-error');
  var contentEl    = document.getElementById('orders-content');
  var filtersEl    = document.getElementById('orders-filters');
  var listEl       = document.getElementById('orders-list');
  var emptyEl      = document.getElementById('orders-empty');
  var paginationEl = document.getElementById('orders-pagination');
  var countEl      = document.getElementById('orders-count');
  var searchInput  = document.getElementById('orders-search');
  var dateFromInput = document.getElementById('orders-date-from');
  var dateToInput  = document.getElementById('orders-date-to');
  var statusSelect = document.getElementById('orders-status');

  // ── State ──────────────────────────────────────────────────
  var currentPage = 1;
  var totalPages = 1;
  var totalCount = 0;
  var expandedOrderNum = null;
  var detailCache = {};
  var debounceTimer = null;
  var reorderInProgress = false;

  // ── Helpers ────────────────────────────────────────────────
  function fmt(n) {
    if (n == null) return '$0.00';
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function statusLabel(s) {
    if (s === 'processing') return 'Processing';
    if (s === 'shipped') return 'Shipped';
    if (s === 'cancelled') return 'Cancelled';
    return s || 'Unknown';
  }

  function chevronSvg() {
    return '<svg class="order-row__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
  }

  function packageSvg() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B3B3B3" stroke-width="2"><path d="M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>';
  }

  // ── Fetch orders list ──────────────────────────────────────
  function fetchOrders() {
    var params = new URLSearchParams();
    params.set('page', currentPage);
    params.set('pageSize', PAGE_SIZE);
    var search = searchInput ? searchInput.value.trim() : '';
    if (search) params.set('search', search);
    var dateFrom = dateFromInput ? dateFromInput.value : '';
    if (dateFrom) params.set('dateFrom', dateFrom);
    var dateTo = dateToInput ? dateToInput.value : '';
    if (dateTo) params.set('dateTo', dateTo);
    var status = statusSelect ? statusSelect.value : 'all';
    if (status !== 'all') params.set('status', status);

    fetch('/apps/purchase-history/orders?' + params.toString(), { method: 'POST', credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        if (data.error) throw new Error(data.error);
        totalCount = data.totalCount;
        totalPages = data.totalPages;
        currentPage = data.page;
        render(data.orders);
      })
      .catch(function(err) {
        console.error('Orders fetch error:', err);
        loadingEl.style.display = 'none';
        errorEl.style.display = '';
        filtersEl.style.display = 'none';
        contentEl.style.display = 'none';
      });
  }

  // ── Fetch order detail ─────────────────────────────────────
  function fetchDetail(orderNumber, callback) {
    var key = orderNumber;
    if (detailCache[key]) {
      callback(detailCache[key]);
      return;
    }

    var num = orderNumber.replace(/^#/, '');
    fetch('/apps/purchase-history/orders/' + encodeURIComponent(num), { method: 'POST', credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        if (!data.error) {
          detailCache[key] = data;
        }
        callback(data);
      })
      .catch(function(err) {
        console.error('Order detail error:', err);
        callback({ error: 'Failed to load order details' });
      });
  }

  // ── Render list ────────────────────────────────────────────
  function render(orders) {
    loadingEl.style.display = 'none';
    contentEl.style.display = '';
    filtersEl.style.display = '';

    countEl.textContent = totalCount + ' order' + (totalCount !== 1 ? 's' : '');

    if (orders.length === 0) {
      listEl.innerHTML = '';
      emptyEl.style.display = '';
      paginationEl.innerHTML = '';
      return;
    }

    emptyEl.style.display = 'none';

    var html = '';
    for (var i = 0; i < orders.length; i++) {
      var o = orders[i];
      var isExpanded = expandedOrderNum === o.orderNumber;

      html += '<div class="order-row" data-order="' + esc(o.orderNumber) + '">';

      // Summary row
      html += '<div class="order-row__summary" onclick="window.__ordersToggle(\'' + esc(o.orderNumber) + '\')">';

      // Thumbnail
      if (o.firstItemImage) {
        html += '<img class="order-row__thumb" src="' + esc(o.firstItemImage) + '" alt="" loading="lazy">';
      } else {
        html += '<div class="order-row__thumb order-row__thumb--placeholder">' + packageSvg() + '</div>';
      }

      // Info
      html += '<div class="order-row__info">';
      if (o.momOrderNumber) {
        html += '<div class="order-row__number">Order #' + esc(o.momOrderNumber);
        html += '<span class="order-row__mom">(' + esc(o.orderNumber) + ')</span>';
        html += '</div>';
      } else {
        html += '<div class="order-row__number">' + esc(o.orderNumber) + '</div>';
      }
      html += '<div class="order-row__meta">' + fmtDate(o.processedAt) + ' &middot; ' + o.itemCount + ' item' + (o.itemCount !== 1 ? 's' : '');
      if (o.firstItemTitle) {
        html += ' &middot; ' + esc(o.firstItemTitle);
      }
      html += '</div>';
      html += '</div>';

      // Right side
      html += '<div class="order-row__right">';
      html += '<span class="order-row__total">' + fmt(o.totalPrice) + '</span>';
      html += '<span class="order-row__status order-row__status--' + o.displayStatus + '">' + statusLabel(o.displayStatus) + '</span>';
      html += '<span class="order-row__chevron' + (isExpanded ? ' order-row__chevron--open' : '') + '">' + chevronSvg() + '</span>';
      html += '</div>';

      html += '</div>'; // end summary

      // Detail container
      html += '<div class="order-detail" id="detail-' + esc(o.orderNumber) + '" style="display:' + (isExpanded ? '' : 'none') + '">';
      if (isExpanded && detailCache[o.orderNumber]) {
        html += renderDetail(detailCache[o.orderNumber]);
      } else if (isExpanded) {
        html += '<div class="order-detail__loading">Loading order details...</div>';
      }
      html += '</div>';

      html += '</div>'; // end order-row
    }

    listEl.innerHTML = html;
    renderPagination();

    // If an order was expanded and detail already loading, trigger fetch
    if (expandedOrderNum && !detailCache[expandedOrderNum]) {
      fetchDetail(expandedOrderNum, function(data) {
        var el = document.getElementById('detail-' + expandedOrderNum);
        if (el) el.innerHTML = renderDetail(data);
      });
    }
  }

  // ── Render order detail ────────────────────────────────────
  function renderDetail(data) {
    if (data.error) {
      return '<div class="order-detail__loading">' + esc(data.error) + '</div>';
    }

    var html = '';

    // Line items
    html += '<div class="order-detail__section">';
    html += '<h3 class="order-detail__section-title">Items</h3>';
    var items = data.lineItems || [];
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      html += '<div class="order-detail__line-item">';
      if (li.imageUrl) {
        html += '<img class="order-detail__li-image" src="' + esc(li.imageUrl) + '" alt="" loading="lazy">';
      } else {
        html += '<div class="order-detail__li-image" style="display:flex;align-items:center;justify-content:center">' + packageSvg() + '</div>';
      }
      html += '<div class="order-detail__li-info">';
      html += '<div class="order-detail__li-title">' + esc(li.productTitle);
      if (li.title && li.title !== li.productTitle && li.title !== 'Default Title') {
        html += ' <span style="color:#7A7A7A">- ' + esc(li.title) + '</span>';
      }
      html += '</div>';
      if (li.sku) {
        html += '<div class="order-detail__li-sku">SKU: ' + esc(li.sku) + '</div>';
      }
      html += '</div>';
      html += '<span class="order-detail__li-qty">x' + li.quantity + '</span>';
      html += '<span class="order-detail__li-price">' + fmt(li.unitPrice) + '</span>';
      html += '</div>';
    }
    html += '</div>';

    // Tracking
    var fulfillments = data.fulfillments || [];
    var hasTracking = false;
    for (var fi = 0; fi < fulfillments.length; fi++) {
      var f = fulfillments[fi];
      var tracking = f.tracking || [];
      for (var ti = 0; ti < tracking.length; ti++) {
        if (tracking[ti].number) {
          hasTracking = true;
          break;
        }
      }
      if (hasTracking) break;
    }

    if (hasTracking) {
      html += '<div class="order-detail__section">';
      html += '<h3 class="order-detail__section-title">Tracking</h3>';
      for (var fi2 = 0; fi2 < fulfillments.length; fi2++) {
        var f2 = fulfillments[fi2];
        var tr = f2.tracking || [];
        for (var ti2 = 0; ti2 < tr.length; ti2++) {
          var t = tr[ti2];
          if (t.number) {
            if (t.url) {
              html += '<a href="' + esc(t.url) + '" target="_blank" rel="noopener" class="order-detail__tracking">';
              html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>';
              html += (t.company ? esc(t.company) + ': ' : '') + esc(t.number);
              html += '</a> ';
            } else {
              html += '<span style="font-size:14px;color:#4D4D4D">';
              html += (t.company ? esc(t.company) + ': ' : '') + esc(t.number);
              html += '</span> ';
            }
          }
        }
      }
      html += '</div>';
    }

    // Order totals
    html += '<div class="order-detail__section">';
    html += '<div class="order-detail__totals">';
    html += '<div class="order-detail__total-row"><span>Subtotal</span><span>' + fmt(data.subtotal) + '</span></div>';
    if (data.discounts > 0) {
      html += '<div class="order-detail__total-row"><span>Discounts</span><span style="color:#27ae60">-' + fmt(data.discounts) + '</span></div>';
    }
    html += '<div class="order-detail__total-row"><span>Shipping</span><span>' + fmt(data.shipping) + '</span></div>';
    html += '<div class="order-detail__total-row"><span>Tax</span><span>' + fmt(data.tax) + '</span></div>';
    html += '<div class="order-detail__total-row order-detail__total-row--grand"><span>Total</span><span>' + fmt(data.total) + '</span></div>';
    html += '</div>';
    html += '</div>';

    // Shipping address
    if (data.shippingAddress) {
      var sa = data.shippingAddress;
      html += '<div class="order-detail__section">';
      html += '<h3 class="order-detail__section-title">Shipping Address</h3>';
      html += '<div class="order-detail__address">';
      html += esc(sa.firstName + ' ' + sa.lastName);
      if (sa.company) html += '<br>' + esc(sa.company);
      html += '<br>' + esc(sa.address1);
      if (sa.address2) html += '<br>' + esc(sa.address2);
      html += '<br>' + esc(sa.city) + ', ' + esc(sa.provinceCode) + ' ' + esc(sa.zip);
      html += '</div>';
      html += '</div>';
    }

    // Note
    if (data.note) {
      html += '<div class="order-detail__section">';
      html += '<h3 class="order-detail__section-title">Order Notes</h3>';
      html += '<div class="order-detail__note">' + esc(data.note) + '</div>';
      html += '</div>';
    }

    // Actions
    html += '<div class="order-detail__actions">';

    var reorderableItems = items.filter(function(li) { return li.canReorder; });
    if (reorderableItems.length > 0 && data.displayStatus !== 'cancelled') {
      html += '<button class="order-detail__reorder-btn" onclick="window.__ordersReorder(\'' + esc(data.orderNumber) + '\')">';
      html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>';
      html += 'Reorder all items';
      html += '</button>';
    }

    html += '<button class="order-detail__print-btn" onclick="window.__ordersPrint(\'' + esc(data.orderNumber) + '\')">';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>';
    html += 'Print Order';
    html += '</button>';

    html += '</div>';

    return html;
  }

  // ── Render pagination ──────────────────────────────────────
  function renderPagination() {
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }

    var html = '';
    html += '<button class="orders-pagination__btn" onclick="window.__ordersPage(' + (currentPage - 1) + ')"' + (currentPage <= 1 ? ' disabled' : '') + '>&laquo; Prev</button>';
    html += '<span class="orders-pagination__info">Page ' + currentPage + ' of ' + totalPages + '</span>';
    html += '<button class="orders-pagination__btn" onclick="window.__ordersPage(' + (currentPage + 1) + ')"' + (currentPage >= totalPages ? ' disabled' : '') + '>Next &raquo;</button>';

    paginationEl.innerHTML = html;
  }

  // ── Toggle expand/collapse ─────────────────────────────────
  window.__ordersToggle = function(orderNumber) {
    if (expandedOrderNum === orderNumber) {
      // Collapse
      expandedOrderNum = null;
      var el = document.getElementById('detail-' + orderNumber);
      if (el) el.style.display = 'none';
      // Reset chevron
      var row = document.querySelector('[data-order="' + orderNumber + '"] .order-row__chevron');
      if (row) row.classList.remove('order-row__chevron--open');
      return;
    }

    // Collapse previous
    if (expandedOrderNum) {
      var prevEl = document.getElementById('detail-' + expandedOrderNum);
      if (prevEl) prevEl.style.display = 'none';
      var prevChev = document.querySelector('[data-order="' + expandedOrderNum + '"] .order-row__chevron');
      if (prevChev) prevChev.classList.remove('order-row__chevron--open');
    }

    // Expand new
    expandedOrderNum = orderNumber;
    var detailEl = document.getElementById('detail-' + orderNumber);
    if (detailEl) {
      detailEl.style.display = '';
      var chev = document.querySelector('[data-order="' + orderNumber + '"] .order-row__chevron');
      if (chev) chev.classList.add('order-row__chevron--open');

      if (detailCache[orderNumber]) {
        detailEl.innerHTML = renderDetail(detailCache[orderNumber]);
      } else {
        detailEl.innerHTML = '<div class="order-detail__loading">Loading order details...</div>';
        fetchDetail(orderNumber, function(data) {
          if (expandedOrderNum === orderNumber) {
            detailEl.innerHTML = renderDetail(data);
          }
        });
      }
    }
  };

  // ── Reorder ────────────────────────────────────────────────
  window.__ordersReorder = function(orderNumber) {
    if (reorderInProgress) return;
    var detail = detailCache[orderNumber];
    if (!detail || !detail.lineItems) return;

    var reorderableItems = detail.lineItems.filter(function(li) { return li.canReorder && li.variantId; });
    if (reorderableItems.length === 0) return;

    reorderInProgress = true;
    var btn = document.querySelector('[data-order="' + orderNumber + '"] .order-detail__reorder-btn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding to cart...';
    }

    var cartItems = [];
    for (var i = 0; i < reorderableItems.length; i++) {
      var li = reorderableItems[i];
      var numId = li.variantId.replace('gid://shopify/ProductVariant/', '');
      cartItems.push({ id: parseInt(numId, 10), quantity: li.quantity });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems }),
      credentials: 'same-origin'
    })
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('Reorder error:', err);
      reorderInProgress = false;
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg> Reorder all items';
      }

      // Show skipped items warning
      var skippedItems = detail.lineItems.filter(function(li) { return !li.canReorder; });
      var detailEl = document.getElementById('detail-' + orderNumber);
      if (detailEl && skippedItems.length > 0) {
        var existing = detailEl.querySelector('.order-detail__skipped');
        if (!existing) {
          var skippedHtml = '<div class="order-detail__skipped">Some items could not be added (out of stock or discontinued): ';
          skippedHtml += skippedItems.map(function(li) { return '<strong>' + esc(li.productTitle) + '</strong>'; }).join(', ');
          skippedHtml += '</div>';
          detailEl.insertAdjacentHTML('beforeend', skippedHtml);
        }
      } else {
        alert('Some items could not be added to cart. They may be out of stock.');
      }
    });
  };

  // ── Print single order ─────────────────────────────────────
  window.__ordersPrint = function(orderNumber) {
    var row = document.querySelector('[data-order="' + orderNumber + '"]');
    if (!row) return;
    var detailEl = document.getElementById('detail-' + orderNumber);
    if (!detailEl || detailEl.style.display === 'none') return;

    // Mark body + order row for single-order print mode
    document.body.classList.add('printing-single-order');
    row.setAttribute('data-print', '');
    detailEl.style.display = '';
    window.print();
    document.body.classList.remove('printing-single-order');
    row.removeAttribute('data-print');
  };

  // ── Page navigation ────────────────────────────────────────
  window.__ordersPage = function(page) {
    if (page < 1 || page > totalPages) return;
    currentPage = page;
    expandedOrderNum = null;
    fetchOrders();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Filter event handlers ──────────────────────────────────
  function onFilterChange() {
    currentPage = 1;
    expandedOrderNum = null;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchOrders, DEBOUNCE_MS);
  }

  function onFilterImmediate() {
    currentPage = 1;
    expandedOrderNum = null;
    fetchOrders();
  }

  if (searchInput) searchInput.addEventListener('input', onFilterChange);
  if (dateFromInput) dateFromInput.addEventListener('change', onFilterImmediate);
  if (dateToInput) dateToInput.addEventListener('change', onFilterImmediate);
  if (statusSelect) statusSelect.addEventListener('change', onFilterImmediate);

  // ── Init ───────────────────────────────────────────────────
  fetchOrders();

})();
